import { faGithub } from '@fortawesome/free-brands-svg-icons/faGithub';
import { faFacebookF } from '@fortawesome/free-brands-svg-icons/faFacebookF';
// import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons/faLinkedinIn';
// import { faAngellist } from '@fortawesome/free-brands-svg-icons/faAngellist';
// import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons/faEnvelope';
import { faOrcid } from '@fortawesome/free-brands-svg-icons/faOrcid';
import { faGoogle } from '@fortawesome/free-brands-svg-icons/faGoogle';
import { faStackOverflow } from '@fortawesome/free-brands-svg-icons/faStackOverflow';
// See https://fontawesome.com/icons?d=gallery&s=brands,regular&m=free
// to add other icons.

const data = [
  {
    link: 'https://github.com/bkb3',
    label: 'Github',
    icon: faGithub,
  },
  {
    link: 'https://stackoverflow.com/users/16330083/cmbfast',
    label: 'StackOverflow',
    icon: faStackOverflow,
  },
  {
    link: 'https://facebook.com/bkb112',
    label: 'Facebook',
    icon: faFacebookF,
  },
  {
    link: 'https://www.linkedin.com/in/bikash-bhandari-211844213/',
    label: 'LinkedIn',
    icon: faLinkedinIn,
  },
  {
    link: 'https://scholar.google.co.nz/citations?user=vC7RldwAAAAJ&hl=en',
    label: 'Scholar Google',
    icon: faGoogle,
  },
  {
    link: 'https://orcid.org/0000-0001-8698-5258',
    label: 'ORCID',
    icon: faOrcid,
  },
  {
    link: 'mailto:mk.bikash@gmail.com',
    label: 'Email',
    icon: faEnvelope,
  },
];

export default data;
